
<template>
  <div class="v0-style"></div>
</template>

<script>
export default {
  name: 'V0Style',
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {},
  Configuration: {
    componentTitle: '无风格',
    componentName: 'V0Style',
    componentOverViewImg: './img/styles/style.png',
    propertyData: {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.v0-style {
  color: white;
}
</style>